<template>
	<layout-splash>
		<div class="card">
			<div class="card-header">{{ offerHeader }} {{ __("is updated") }}!</div>
			<div class="card-body">
				<div class="alert alert-success" role="alert">
					{{ offerHeader }}
					{{
						__(
							"has been marked as current. remember keeping cropspot up to date"
						)
					}}!
				</div>
			</div>
		</div>
		<tradable-terms-summary :offer="tradable"></tradable-terms-summary>
	</layout-splash>
</template>

<script>
export default {
	props: {
		offerHeader: {
			type: String,
			required: true,
		},
		tradable: {
			type: Object,
			required: true,
		},
	},
};
</script>
